/** @format */

import React, { PureComponent } from 'react';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import I18n from '../../components/Translate/I18n';
import { PlusOrdersCommonResponse } from '../../interfaces/platform/PlusOrdersCommonResponse';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { Typography } from '@material-ui/core';
import { PlkRequestView } from './PlkRequestView';
import { PlkResponseView } from './PlkResonseView';
import { PlusOrdersCommonResponseView } from '../Provisioning/components/PlusOrdersCommonResponseView';
import { GetSubscriptionProps } from '../../modules/plkFunctions/PlkTypesInterface';
import ClientSubscrChangeTariff from '../../modules/plkFunctions/ClientSubscrChangeTariff';

const _ = require('underscore');

class ClientSubscrChangeTariffView extends PureComponent<GetSubscriptionProps> {
    private getSubscription: ClientSubscrChangeTariff;

    constructor(props: GetSubscriptionProps, context: any) {
        super(props, context);
        const { item } = this.props;
        this.getSubscription = new ClientSubscrChangeTariff(item);
    }

    viewXml = (elm: PlusOrdersCommonResponse): void => {
        const { viewDialog } = this.props;
        viewDialog(
            <I18n trans={'prov:api.api_plk_method_call'} valueObject={{ function_name: elm.command }} />,
            <PlusOrdersCommonResponseView item={elm} />
        );
    };

    render(): React.ReactNode {
        const { item } = this.props;
        let counter = 0;

        return item.tableResponse.map((response: PlusOrdersCommonResponse) => {
            return (
                <GridContainer key={'plus_common_response_key_' + response.id}>
                    <GridItem xs={4}>
                        <PlkRequestView getSubscription={this.getSubscription} item={item} counter={++counter} />
                    </GridItem>
                    <GridItem xs={4}>
                        <PlkResponseView getSubscription={this.getSubscription} item={item} counter={counter} />
                    </GridItem>
                    <GridItem xs={4}>
                        <GridContainer>
                            <GridItem xs={12}>
                                <Typography variant="subtitle2">
                                    <I18n trans="prov:vb.block_reaction" />
                                </Typography>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem xs={12} style={{ textAlign: 'right' }}>
                        <CustomTextButtom
                            callback={this.viewXml}
                            callbackParam={this.getSubscription.getPlusOrdersCommonResponse(counter - 1)}
                            label="prov:vb.view_xml_plk"
                        />
                    </GridItem>
                </GridContainer>
            );
        });
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(ClientSubscrChangeTariffView);
